/**
 * 하위 호환성을 위한 re-export
 * 실제 구현은 ./websocket/ 디렉토리에 있습니다.
 */
export {
  useWebSocket,
  isProgressUpdate,
  isTrackProgress,
  isErrorNotification,
  isCompletionNotification,
  isLogMessage,
  isControlResponse,
  isCostUpdate,
  isStatsUpdate,
  isInitialDashboardData,
} from './websocket';

export type {
  UseWebSocketReturn,
  UseWebSocketOptions,
  WebSocketStatus,
  WebSocketMessage,
  ProgressUpdate,
  TrackProgress,
  ErrorNotification,
  CompletionNotification,
  LogMessage,
  VersionCreated,
  ConnectionEstablished,
  ControlResponse,
  CostUpdateMessage,
  StatsUpdateMessage,
  InitialDashboardMessage,
} from './websocket';
